module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAAAAXNSR0IArs4c6QAAAKtJREFUOBGl1MENhSAQBFDx7t38hixL7UobsoDvXcwYJRIXd3YlISLJPOZAqKpzrPNvwLz+TV8E/1MbMa1IQCDGrb+fGEI9Nt1CtanvwWsNkG0SEJJaYJ9pcgBfkAR4kQzwIA/AioiABSkCLPIKMIgKaIh4ExFih9pAu6WvgBZGyyLAhIsAGxYBS/gBWMMZ4AknwBs+gC9hAOJNZJ4yhNNAC++zniGA0ga52AEEYruUE9AqUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow@2x.png
// module id = 365
// module chunks = 0